<template>
  <div class="visibility-select">
    <button
      v-for="opt in options"
      :key="opt.value"
      type="button"
      class="v-btn"
      :class="{ active: value === opt.value }"
      @click="$emit('input', opt.value)"
    >
      <span>{{ opt.icon }}</span> {{ opt.text }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'VisibilitySelect',
  props: {
    value: { type: String, default: 'trip' },
    allowPublic: { type: Boolean, default: true }
  },
  computed: {
    options () {
      const all = [
        { value: 'private', text: '只有我', icon: '🔒' },
        { value: 'trip', text: '旅伴', icon: '👥' },
        { value: 'public', text: '公開', icon: '🌍' }
      ]
      return this.allowPublic ? all : all.filter(o => o.value !== 'public')
    }
  }
}
</script>

<style scoped>
.visibility-select {
  display: flex;
  gap: 8px;
}
.v-btn {
  flex: 1;
  padding: 8px 4px;
  border-radius: var(--radius-md);
  border: 1px solid var(--color-border);
  background: #fff;
  font-size: 12px;
  color: var(--color-text-dim);
}
.v-btn.active {
  border-color: var(--color-primary);
  background: #fff5f0;
  color: var(--color-primary-dark);
  font-weight: 600;
}
</style>
